export { SegmentedControl } from './segmented-control'
